import { useCallback, useMemo } from "react";

import qs from "query-string";
import { Trans } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { gql, client } from "../../bit/board/hooks/useGraphQLClient";

import Modal from "../../components/Modal";

import { useDebounceStatus } from "../../lib/hooks/useDebounceStatus";
import { useTimeoutFunction } from "../../lib/hooks/useTimeoutFunction";
import { useCheckinAccessNavigation } from "../../lib/hooks/useCheckinAccessNavigation";

const MUTATION_ACCESS_EVENT_SEND_TEAMS_MESSAGE = gql`
  mutation accessEventSendTeamsMessage($id: ID!) {
    accessEventSendTeamsMessage(id: $id) {
      id
    }
  }
`;

const TeamsMessage = () => {
  const navigate = useNavigate();

  const { search } = useLocation();
  const query = qs.parse(search);
  const type = query.type as string;

  const { id } = useParams<{ id: string }>();

  // const { trackEvent } = useEventTracking();

  const {
    handleCheckinAccessNavigation,
    willNavigateToCheckinAccessControlPage,
    isDoorOpening,
    accessSwitchModal,
  } = useCheckinAccessNavigation({ type });

  const { status: requestStatus } = useQuery(
    [`access/event/${id}/teams-message`],
    () => {
      return client.request(MUTATION_ACCESS_EVENT_SEND_TEAMS_MESSAGE, {
        id,
      });
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      onSuccess() {
        // trackEvent({
        //   type: "message_send",
        //   value: "success",
        // });
      },
      onError() {
        // trackEvent({
        //   type: "message_send",
        //   value: "error",
        // });
      },
    },
  );

  const onDismiss = useCallback(() => {
    /**
     * Redirect to previous route in case of error so you can retry
     */
    if (requestStatus === "error") {
      return navigate(-1);
    }

    return handleCheckinAccessNavigation();
  }, [requestStatus]);

  const status = useDebounceStatus(requestStatus, 1500);

  const timeout = useMemo(() => {
    if (status === "error") {
      return 10000;
    }

    if (status === "success") {
      return 3000;
    }

    return 0;
  }, [status]);

  useTimeoutFunction(onDismiss, timeout);

  const statusKey = useMemo(() => {
    if (willNavigateToCheckinAccessControlPage && status === "success") {
      return "successAccess";
    }
    return status;
  }, [willNavigateToCheckinAccessControlPage, status]);

  if (isDoorOpening) {
    return accessSwitchModal;
  }

  return (
    <Modal
      title={<Trans i18nKey={`teamsMessage:status.${statusKey}.title`} />}
      message={<Trans i18nKey={`teamsMessage:status.${statusKey}.message`} />}
      status={status}
      onDismiss={onDismiss}
    />
  );
};

export default TeamsMessage;
